import { defineMessages } from "react-intl";
const messages = defineMessages({
    inactiveCommunity: {
        id: "app.admin.communities.chip.inactive",
        defaultMessage: "Inactive",
    },
    noCommunities: {
        id: "app.admin.communities.table.noData.text",
        defaultMessage: "No communities available.",
    },
    communityName: {
        id: "app.admin.communities.table.head.communityName.text",
        defaultMessage: "Name",
    },
    organizationName: {
        id: "app.admin.communities.table.head.organizationName.text",
        defaultMessage: "Organization",
    },
    id: {
        id: "app.admin.communities.table.head.id.text",
        defaultMessage: "Id",
    },
    dxSettingPMS: {
        id: "app.admin.communities.table.head.dxSettingPMS.text",
        defaultMessage: "PMS",
    },
    dxSettingCRM: {
        id: "app.admin.communities.table.head.dxSettingCRM.text",
        defaultMessage: "CRM",
    },
    dxSettingILS: {
        id: "app.admin.communities.table.head.dxSettingILS.text",
        defaultMessage: "ILS",
    },
});
export default messages;
